import { cn } from "@arcadeai/design-system/lib/utils";
import { ChevronRight } from "lucide-react";
import { motion } from "motion/react";
import type { ReactNode } from "react";

type TerminalLineProps = {
  children: ReactNode;
  color?: "emerald" | "amber" | "red" | "neutral";
  delay?: number;
  icon?: ReactNode;
};

const colorClasses = {
  emerald: "text-emerald-600 dark:text-emerald-500",
  amber: "text-amber-600 dark:text-amber-500",
  red: "text-red-600 dark:text-red-500",
  neutral: "text-neutral-500 dark:text-neutral-500",
};

export function TerminalLine({
  children,
  color = "emerald",
  delay = 0,
  icon,
}: TerminalLineProps) {
  return (
    <motion.div
      animate={{ opacity: 1 }}
      className="flex items-center font-mono text-sm"
      initial={{ opacity: 0.7 }}
      transition={{ duration: 0.15, delay, ease: "easeOut" }}
    >
      {icon ?? (
        <ChevronRight
          className={cn("mr-1 h-4 w-4 shrink-0", colorClasses[color])}
        />
      )}
      {children}
    </motion.div>
  );
}
